import {Message} from "element-ui";

//const Msg = {};

export default Message
